import { createApiAction } from '@app/packages/api/utils'
import type { ApiSchoolRequest } from '@app/packages/api/v2/types/entities'
import type { PostSchoolRequestsRequest } from '@app/packages/api/v2/types/params'

export const postSchoolRequests = (request: PostSchoolRequestsRequest) =>
  createApiAction('postSchoolRequests', dispatch =>
    dispatch<{ data: ApiSchoolRequest }>({ method: 'POST', endpoint: '/api/v2/school_requests', body: JSON.stringify(request) })
  )
